import { ofType } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import {
    Prescription,
    setAction,
    reinitAction,
} from 'one-state-prescription';
import {
    setAction as setSkeletonAction
} from 'one-state-skeleton';
import {
    Skeleton,
} from 'one-model-local';

import {
    SETSELECTED,
    RESET,
    SET,
} from 'one-state-subject/src/types';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';

import {
    addAction
} from 'one-state-error/src/actions';

export const enum Types {
    PRESCRIPTION = 'prescription-select',
    PRESCRIPTIONCLEAR = 'prescription-clear',
}

function sortFunction(a: Prescription, b: Prescription) {
    const dateA = new Date(a.startdate).getTime();
    const dateB = new Date(b.startdate).getTime();
    return dateA > dateB ? 1 : -1;
}

const pushToSkeleton = (payload: any) => setSkeletonAction(payload);

export const fetchPrescriptionEpic = (context: any) => (
    (action$: any) => {
        const { server, settings: { epicendpoints: { patientprescription, apitoken } }, log } = context;
        return action$.pipe(
            ofType(SETSELECTED),
            mergeMap((action: any) => {
                var dataresponse = action.payload;

                const getRequest = (datares: any) => {
                    if (datares?.id) {
                        let headers = new Headers();
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        const data = {
                            //"PatientID": datares?.id
                            "patientMRN":datares.prescriptionMRNData,
                            //"prescriptionId":"A6000420"
                        }
                        const response = server.post({
                            path: patientprescription,
                            data: data,
                            headers: headers
                        })
                            .then((responsedata: any) => responsedata).catch((responseerror: any) => {
                                log.error(
                                    'ccw-gadget-prescription-epic',
                                    'fetch-prescription-epic', {
                                    responseerror
                                }
                                );
                                let errorbuild: ErrorObject = {
                                    source: "Prescription",
                                    type: "error",
                                    status: responseerror?.status,
                                    erroritems: responseerror?.errors
                                };
                                return errorbuild;
                            })
                        log.debug(
                            "ccw-gadget,prescription-epic",
                            "fetch-fetchPrescription-epic", {
                            response
                        });
                        return from(response)
                    }
                    else {
                        return from([]);
                    }

                }

                return getRequest(dataresponse).
                    pipe(
                        map((response: any) => TransformResponse(response, context)))
                    .pipe(
                        flatMap(response => {
                            const actions: any = [
                                setAction(response.prescriptiondata)
                            ];

                            if (response.error) {
                                actions.push(addAction(response.error));
                            }
                            // clear skeleton for prescription
                            let skeletonPrescription: Skeleton = {
                                prescription_skeleton: false
                            }
                            actions.push(pushToSkeleton(skeletonPrescription));
                            return actions;
                        })
                    )
            })
        )
    }
);

export const pushClearPrescription = (context: any) => (
    (action$: any) => {
        return action$.pipe(
            ofType(SET, RESET),
            map(action => reinitAction()
        ))
    }
);

const TransformResponse = (response: any, context: any) => {
    const { log } = context;
    log.debug(
        'ccw-gadget-prescription-transformation-request',
        response);
    let prescriptiondata: Prescription[] = [];
    let result: any = {
        prescriptiondata: prescriptiondata,
        error: undefined
    }
    if (response && (response.status >= 400 || response.type == "error")) {
        result.error = response;
    }
    if (response?.Prescriptions?.Prescription && response?.Prescriptions?.Prescription?.length > 0) {
        response.Prescriptions.Prescription.forEach((ele: any) => {
            let prescription: Prescription = {
                startdate: "",
                medication: "",
                prescriptionstatus: "",
                fillsremaining:"",
                authorizingprovider:"",
                transmissionmethod:""
            }
            prescription.medication = ele?.Medication ? ele.Medication : "";
            prescription.startdate = ele?.StartDate ? ele.StartDate : "";
            prescription.prescriptionstatus = ele?.Status ? ele.Status : "";
            prescription.fillsremaining = ele?.FillsRemaining ? ele.FillsRemaining : "";
            prescription.authorizingprovider = ele?.AuthorizingProviderDisplayName ? ele.AuthorizingProviderDisplayName : "";
            prescription.transmissionmethod= "";
            prescriptiondata.push(prescription);
        })
        prescriptiondata.sort(sortFunction)
    }
    result.prescriptiondata = prescriptiondata;
    log.debug(
        'ccw-gadget-prescription-transformation-response',
        result);
    return result;
}